export enum STOCK_ADJUSTMENT_STATUS {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
}
export enum STOCK_ADJUSTMENT_REASONS {
  SPOILAGE = 'Spoilage',
  WASTE = 'Waste',
  INCORRECT_DELIVERY = 'Incorrect Deliveries',
  THEFT_OR_PILFERAGE = 'Theft or Pilferage',
  EMPLOYEE_ERROR_IN_RECORDING = 'Employee Error in Recording',
  MENU_CHANGES_OR_NEW_DISHES = 'Menu Changes or New Dishes',
  SUPPLIER_SHORTAGE_OR_OVERAGES = 'Supplier Shortages or Overages',
  FOOD_PREPARATION_WASTE = 'Food Preparation Waste',
  SEASONAL_VARIATIONS_IN_DEMAND = 'Seasonal Variations in Demand',
  INCORRECT_PORTIONING = 'Incorrect Portioning',
  SPECIAL_PROMOTIONS_OR_EVENTS = 'Special Promotions or Events',
  ACCIDENTAL_DAMAGE_TO_STOCK = 'Accidental Damage to Stock',
  UNRECORDED_SALES_OR_TRANSFER = 'Unrecorded Sales or Transfers',
  CHANGE_IN_VENDOR_PACKAGING = 'Change in Vendor Packaging',
  EXPIRED = 'Expired',
  INV_SHRINKAGE_DUE_TO_MISMANAGEMENT = 'Inv Shrinkage Due to Mismanagement',
  NEW_DELIVERY = 'New Delivery',
  OTHER = 'Other',
}

export enum STOCK_TYPE {
  INGREDIENT = 'Ingredient',
  PREP_RECIPE = 'Prep Recipe',
}

export enum STOCK_TYPE_VARIABLE_FIELD {
  INGREDIENT = 'ingredient',
  RECIPE = 'recipe',
}
